import { Loader } from '@pwc/pwc-deals-ui';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { EmptyClipboardModal } from 'common/components/EmptyClipboardModal';
import { getAnalysisDescription } from '../../../../../common/engine/reducers/structuredDocumentDescriptionSlice';

import BasisOfPresentationEditor from './BasisOfPresentationEditor';
import AdjustmentDescriptionEditor from './AdjustmentDescriptionEditor';

import './AnalysisRichtextDescription.scss';

const AnalysisRichtextDescription = ({
  projectId,
  isReadonly,
  lightModeVariant,
  config,
  documentCode,
  onChange,
  descriptions,
  contentType,
}) => {
  const [noDataOnClipboard, setNoDataOnClipboard] = useState(false);

  useEffect(() => {
    const container = document.querySelector('#rich-text-editor');
    if (container) {
      container.addEventListener(
        `inserting-minitable-no-data`,
        () => {
          setNoDataOnClipboard(true);
        },
        false
      );
    }
  }, []);

  const { loading, isBasisOfPresentationMode } = useSelector(
    getAnalysisDescription
  );

  const getComponentBody = () => {
    if (loading) {
      return <Loader dataTestId="analysis-description-loader" />;
    }

    return (
      <>
        {isBasisOfPresentationMode && (
          <BasisOfPresentationEditor
            projectId={projectId}
            isReadonly={isReadonly}
            lightModeVariant={lightModeVariant}
            config={config}
            documentCode={documentCode}
            onChange={onChange}
          />
        )}
        {!isBasisOfPresentationMode && (
          <AdjustmentDescriptionEditor
            projectId={projectId}
            isReadonly={isReadonly}
            lightModeVariant={lightModeVariant}
            config={config}
            onChange={onChange}
            descriptions={descriptions}
            contentType={contentType}
          />
        )}
      </>
    );
  };

  return (
    <div
      className="analysis-richtext-description-edit"
      id="analysisDescription"
      aria-live="polite"
    >
      {getComponentBody()}
      {noDataOnClipboard && (
        <EmptyClipboardModal
          show={noDataOnClipboard}
          onHide={() => setNoDataOnClipboard(false)}
        />
      )}
    </div>
  );
};

AnalysisRichtextDescription.propTypes = {
  isReadonly: PropTypes.bool,
};

AnalysisRichtextDescription.defaultProps = {
  isReadonly: false,
};

export default AnalysisRichtextDescription;
